import React from 'react'
import { makeStyles, createStyles } from '@mui/styles'
import List from '@mui/material/List'
import { withRouter } from "react-router-dom";
import { FormattedMessage } from 'react-intl';
import { injectIntl } from 'react-intl'
import RightAppMenuItem from './rightappmenuitem'
import Divider from '@mui/material/Divider'

const RightAppMenu = (props) => {
  const classes = useStyles();

  const appMenuItems = props.appMenuItems;

  return (
    <List component="nav" className={classes.appMenu} disablePadding>
      {appMenuItems.map((item, index) => (
        (item.link != "divider") ? ( 
          <RightAppMenuItem {...item} key={index} />
        )
        :
        ( 
          <Divider   key={index} />
        )
      ))}
    </List>
  )
}

const drawerWidth = 350

const useStyles = makeStyles(theme =>
  createStyles({
    appMenu: {
      width: '100%',
    },
    navList: {
      width: drawerWidth,
    },
    menuItem: {
      width: drawerWidth,
    },
    menuItemIcon: {
      color: '#97c05c',
    },
    listItemTextInset: {
      paddingLeft: 0
    }
  }),
)

export default injectIntl(withRouter(RightAppMenu))
